import React from "react";
import { isWhiteLabelEnabled } from "../utils/config";
import Hero from "../components/home/banner/hero.component";
import NewsLetterComponent from '../components/home/gallery/newsLetter.component';
import ServicesComponentBanner from '../components/home/services/ServicesBanner.component'
import HorizontalTimelineComponent from '../components/home/Timeline/HorizontalTimelineComponent';
// import RoleBasedTimeline from "../components/home/Timeline/RoleBasedTimeline";

const Home = ({ logged_in, language, account, user }) => {
    return (
        // <>
        //     <Hero user={user} />
        //     {isWhiteLabelEnabled() ? (
        //         <RoleBasedTimeline />
        //     ) : (
        //         <>
        //             <ServicesComponentBanner />
        //             <HorizontalTimelineComponent />
        //             <NewsLetterComponent />
        //         </>
        //     )}
        // </>

        <>
        <Hero user={user} />
        {!isWhiteLabelEnabled() && (
            <>
            <ServicesComponentBanner />
            <HorizontalTimelineComponent />
            <NewsLetterComponent />
            </>
        )}
        </>

    );
};

export default Home;
